import { useMemo, useRef } from 'react';
import { UserSetting } from 'src/WebApiController';

import { useServerUserSetting } from './useUserSetting';

export const useFavoriteQuickFilter = (settingId: UserSetting | undefined) => {
  const {
    value: _favoriteQuickFilterId,
    setUserSetting: _setFavoriteQuickFilterId,
  } = useServerUserSetting<string | null>({
    id: settingId,
  });

  const favoriteQuickFilterId = useMemo(() => {
    if (settingId === undefined) {
      return null;
    }
    return _favoriteQuickFilterId ?? null;
  }, [settingId, _favoriteQuickFilterId]);

  const favoriteQuickFilterIdRef = useRef(favoriteQuickFilterId);
  favoriteQuickFilterIdRef.current = favoriteQuickFilterId;
  const setFavoriteQuickFilter = useMemo(() => {
    if (settingId === undefined) {
      return undefined;
    }
    return (filterId: string | null) => {
      if (filterId === favoriteQuickFilterIdRef.current) {
        filterId = null; // Unset if the same filter is selected
      }
      _setFavoriteQuickFilterId(filterId);
    };
  }, [settingId, _setFavoriteQuickFilterId]);

  // Return null and noop setter if settingId is not provided
  return useMemo(
    () => ({
      favoriteQuickFilterId,
      setFavoriteQuickFilter,
    }),
    [favoriteQuickFilterId, setFavoriteQuickFilter]
  );
};
